import {normalizeLoadedFlowQuestions} from '@/utility/flowQuestion';

export default {
    resetSustainabilityConsultationOrder(state) {
        const order = {
            type: 'SUSTAINABILITYCONSULTATION',
            relation: {
                id: null,
                createTimestamp: null,
                modifiedTimestamp: null,
                deletedTimestamp: null,
                isAnonymized: null,
                organizationID: null,
                externalReference: null,
                type: 'CONSUMER',
                isParent: null,
                parentID: null,
                firstName: null,
                middleName: null,
                lastName: null,
                gender: 'MALE',
                birthDate: null,
                phoneNumber: null,
                mobileNumber: null,
                email: null,
                street: null,
                houseNumber: null,
                houseNumberAddition: null,
                postalCode: null,
                city: null,
                country: null,
                companyName: null,
                companyCocNumber: null,
                bankAccountType: null,
                bankAccountNumber: null,
                debtorName: null,
                saveToRevision: false,
            },
            relationID: null,
            signatureType: 'ESIGNATURE',
            signatureData: null,
            productID: null,
            key: Math.random(),
            extraData: {},
            flowQuestions: [],
        };
        state.order = order;
    },

    preFillRelationOnSustainabilityConsultationOrderBegin(state) {
        state.errorPreFillRelationOnOrder = false;
        state.loadingPreFillRelationOnOrder = true;
    },

    preFillRelationOnSustainabilityConsultationOrderSuccess(state) {
        state.loadingPreFillRelationOnOrder = false;
    },

    preFillRelationOnSustainabilityConsultationOrderErr(state, err) {
        state.loadingPreFillRelationOnOrder = false;
        state.errorPreFillRelationOnOrder = err;
    },

    preFillRelationData(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.relation = data;
        order.key = Math.random();
        state.order = order;
    },

    addRelationToSustainabilityConsultationOrder(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));

        if (data.type === 'CONSUMER') {
            data.companyName = null;
            data.companyCocNumber = null;
        }

        order.relation = data;
        if (data.id !== undefined) {
            order.relationID = data.id;
        }
        order.key = Math.random();
        state.order = order;
    },

    createSustainabilityConsultationOrderBegin(state) {
        state.errorCreateOrder = false;
        state.loadingCreateOrder = true;
    },

    createSustainabilityConsultationOrderSuccess(state) {
        state.loadingCreateOrder = false;
    },

    createSustainabilityConsultationOrderErr(state, err) {
        state.loadingCreateOrder = false;
        state.errorCreateOrder = err;
    },

    setSignatureSustainabilityConsultationData(state, data) {
        const order = JSON.parse(JSON.stringify(state.order));
        order.signatureData = data;
        order.key = Math.random();
        state.order = order;
    },

    fetchSustainabilityConsultationFlowQuestionsBegin(state) {
        state.loadingFetchSustainabilityConsultationFlowQuestions = true;
        state.errorFetchSustainabilityConsultationFlowQuestions = false;
    },

    fetchSustainabilityConsultationFlowQuestionsSuccess(state, data) {
        state.loadingFetchSustainabilityConsultationFlowQuestions = false;
        const order = JSON.parse(JSON.stringify(state.order));
        order.flowQuestions = normalizeLoadedFlowQuestions(data.data);
        order.key = Math.random();
        state.order = order;
    },

    fetchSustainabilityConsultationFlowQuestionsErr(state, err) {
        state.loadingFetchSustainabilityConsultationFlowQuestions = false;
        state.errorFetchSustainabilityConsultationFlowQuestions = err;
    },
};

